import {
  NavMySessionIcon,
  NavMyExamIcon,
  NavScheduleSessionIcon,
  NavSupportIcon,
  NavNotificationIcon,
  NavProfileIcon,
} from "../assets/navIcons";
import { MyExam, ScheduleSession, MySession } from "../pages";
import Profile from "../pages/Profile";
import Instructions from "../pages/mySession/Instructions";
import ActiveSessionExam from "../pages/mySession/ActiveSessionExam";
import AvailbleSlots from "../pages/scheduleSession/AvailbleSlots";
import BookExamSlot from "../pages/scheduleSession/BookExamSlot";
import NotVerified from "../pages/mySession/NotVerified";
import RescheduleExamSlot from "../pages/scheduleSession/RescheduleExamSlot";
import RescheduleAvailbleSlots from "../pages/scheduleSession/RescheduleAvailbleSlots";
import Support from "../pages/support/Support";
import { DashbordRoute } from "./adminRoutes";
import SupportTicket from "../pages/support/SupportTicket";

const userRoutes: DashbordRoute[] = [
  {
    key: "01",
    Icon: NavProfileIcon,
    label: "Profile",
    path: "profile",
    Component: Profile,
    hidden: true,
  },
  {
    key: "0",
    Icon: NavScheduleSessionIcon,
    label: "Schedule Session",
    path: "schedule-session",
    Component: ScheduleSession,
    hidden: false,
  },
  {
    key: "01",
    Icon: NavScheduleSessionIcon,
    label: "Schedule Session",
    path: "schedule-session/book-slot/:id",
    Component: BookExamSlot,
    hidden: true,
  },

  {
    key: "01",
    Icon: NavScheduleSessionIcon,
    label: "Schedule Session",
    path: "schedule-session/reschedule/:id",
    Component: RescheduleExamSlot,
    hidden: true,
  },
  {
    key: "02",
    Icon: NavScheduleSessionIcon,
    label: "Schedule Session",
    path: "schedule-session/available-slots/:id",
    Component: AvailbleSlots,
    hidden: true,
  },
  {
    key: "02",
    Icon: NavScheduleSessionIcon,
    label: "Schedule Session",
    path: "schedule-session/reschedule-available-slots/:id",
    Component: RescheduleAvailbleSlots,
    hidden: true,
  },
  {
    key: "1",
    Icon: NavMySessionIcon,
    label: "My Session",
    path: "my-session",
    Component: MySession,
  },
  {
    key: "2",
    Icon: NavMyExamIcon,
    label: "My Exam",
    path: "my-exam",
    Component: MyExam,
  },
  {
    key: "3",
    Icon: NavMyExamIcon,
    label: "My Exam",
    path: "my-session/exam-instructions",
    Component: Instructions,
    hidden: true,
  },
  {
    key: "4",
    Icon: NavMyExamIcon,
    label: "My Exam",
    path: "my-session/not-verified",
    Component: NotVerified,
    hidden: true,
  },
  {
    key: "5",
    Icon: NavMyExamIcon,
    label: "My Exam",
    path: "my-session/active/:id",
    Component: ActiveSessionExam,
    hidden: true,
    search: false,
  },
  {
    key: "6",
    Icon: NavSupportIcon,
    label: "Support",
    path: "support",
    Component: Support,
    hidden: false,
    search: false,
  },
  {
    key: "13",
    Icon: NavNotificationIcon,
    label: "SupportTicket",
    path: "support/:id",
    Component: SupportTicket,
    permission: "user.view",
    search: false,
    hidden: true,
  },
];

export default userRoutes;
